import React, {
    FunctionComponent,
    useMemo,
    // useState
} from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';

import { Config, configs } from '../Config';
import { ArrowButton } from '../../../components/ArrowButton';

type Props = {
    config: Config;
    baseUrl: string;
};

export const Step1: FunctionComponent<Props> = ({ config, baseUrl }) => {
    const { t } = useTranslation();
    const { language, questionId, difficulty } = useParams();

    const nextStepUrl = useMemo(() => {
        const questionIndex = questionId && parseInt(questionId, 10);
        const currentDifficulty = difficulty as 'easy' | 'hard';
        const questionCount = currentDifficulty
            ? config.questions[currentDifficulty].count
            : 0;

        // If count is 0, skip to next question's step_1
        if (questionCount === 0) {
            if (
                currentDifficulty &&
                questionIndex &&
                configs.length > questionIndex
            ) {
                return `/${baseUrl}/${language}/${
                    questionIndex + 1
                }/${currentDifficulty}/step_1`;
            }
            return `/${baseUrl}/${language}/end`;
        }

        // Otherwise go to step_2
        return `/${baseUrl}/${language}/${questionId}/${currentDifficulty}/step_2`;
    }, [baseUrl, config.questions, difficulty, language, questionId]);
    return (
        <>
            <div className={`${config.color || ''} first`}>
                <h1>
                    {t('questions.stage')}
                    <span>{questionId}</span>
                </h1>
                <p className="desc">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t(`questions.${questionId}.desc`),
                        }}
                    />
                </p>
                <img
                    src={config.imageIntro}
                    alt="clue"
                    className="question-image"
                />
            </div>
            <div className={`${config.subcolor || ''} second`}>
                {t(`questions.${questionId}.subdesc`, { defaultValue: '' }) && (
                    <p className="subdesc">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t(`questions.${questionId}.subdesc`),
                            }}
                        />
                    </p>
                )}
                <Link className="next-link" to={nextStepUrl}>
                    <ArrowButton color={config.subcolor} />
                </Link>
            </div>
        </>
    );
};
